import {
  UNCLAIMED_PATIENTS_REQUEST,
  UNCLAIMED_PATIENTS_FAILURE,
  UNCLAIMED_PATIENTS_SUCCESS,
  REORDER_UNCLIAMED_PATIENT_LIST,
  REORDER_UNCLAIMED_PATIENTS_SAGA_TYPE,
} from '../actions/actionTypes';

const initialState = {
  unclaimedPatientList: [],
  isFetchingUnclaimedPatientList: false,
  isErrorInUnclaimedPatientList: null,
};

const unClaimedPatient = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  } else {
    switch (action.type) {
      case UNCLAIMED_PATIENTS_REQUEST:
        return {
          ...state,
          isFetchingUnclaimedPatientList: true,
          isErrorInUnclaimedPatientList: null,
        };
      case UNCLAIMED_PATIENTS_SUCCESS:
        return {
          ...state,
          isFetchingUnclaimedPatientList: false,
          unclaimedPatientList: action.payload,
          isErrorInUnclaimedPatientList: null,
        };
      case UNCLAIMED_PATIENTS_FAILURE:
        return {
          ...state,
          isFetchingUnclaimedPatientList: false,
          isErrorInUnclaimedPatientList: 'SomeThing went wrong.',
        };
      case REORDER_UNCLIAMED_PATIENT_LIST:
      case REORDER_UNCLAIMED_PATIENTS_SAGA_TYPE:
        return {
          ...state,
          isFetchingUnclaimedPatientList: false,
          unclaimedPatientList: [...action.payload],
          isErrorInUnclaimedPatientList: null,
        };

      default:
        return state;
    }
  }
};

export default unClaimedPatient;
